/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Pro Tip Icon component.
 */
export const SystemProTipIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M16.8468 11.3555L10.0046 17.855C9.90463 17.95 9.77305 18 9.63094 18C9.53094 18 9.43621 17.975 9.352 17.925C9.14673 17.8 9.05199 17.56 9.13094 17.3401L10.4783 13.5004H7.52567C7.32041 13.5004 7.13093 13.3854 7.04672 13.2104C6.96251 13.0304 6.99409 12.8254 7.12567 12.6754L12.9152 6.17595C13.0731 6.00097 13.331 5.95097 13.5468 6.05096C13.7678 6.15095 13.8836 6.38594 13.831 6.61092L12.9204 10.5006H16.4731C16.6836 10.5006 16.8783 10.6256 16.9573 10.8106C17.0415 10.9956 16.9994 11.2105 16.8468 11.3555Z' fill={iconColor} />
    </svg>
  );
};

export default SystemProTipIcon;
